import { CircularProgress, Grid, TextField } from '@material-ui/core'
import Autocomplete, {
  createFilterOptions
} from '@material-ui/lab/Autocomplete'
import React, { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { useStyles } from './style'

const filter = createFilterOptions()

export function ContactSelect({
  label,
  onSelected,
  allowCreate = false,
  onCreateContact,
  excludeId,
  placeholder
}) {
  const classes = useStyles()

  const [contacts, setContacts] = useState([])
  const [loading] = useState(false)
  const [searchParam, setSearchParam] = useState('')
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    if (searchParam.length < 2) {
      setContacts([])
      return
    }
    const fetchContacts = async () => {
      try {
        const { data } = await api.get('contacts', { params: { searchParam } })
        let contactList = data.contacts.map(c => ({
          id: c.id,
          name: c.name,
          number: c.number
        }))
        if (excludeId) {
          contactList = contactList.filter(contact => contact.id !== excludeId)
        }
        setContacts(contactList)
      } catch (err) {
        toastError(err)
      }
    }
    fetchContacts()
  }, [searchParam, excludeId, setSelected])

  const handleChange = (event, value) => {
    if (value && value.inputValue && allowCreate && onCreateContact) {
      onCreateContact(value.inputValue)
      setSelected(null)
    } else {
      setSelected(value)
      // ENVIE O OBJETO COMPLETO, NÃO SÓ O ID
      onSelected(value)
    }
  }

  const filterOptions = (options, params) => {
    const filtered = filter(options, params)
    if (
      allowCreate &&
      params.inputValue !== '' &&
      !options.some(option => option.name === params.inputValue)
    ) {
      filtered.push({
        inputValue: params.inputValue,
        name: params.inputValue
      })
    }
    return filtered
  }

  return (
    <Grid container spacing={1} alignItems="flex-end">
      <Grid xs={12} item>
        <Autocomplete
          className={classes.inputAutocomplete}
          size="small"
          fullWidth
          options={contacts}
          value={selected}
          loading={loading}
          onChange={handleChange}
          filterOptions={filterOptions}
          noOptionsText=""
          freeSolo={allowCreate}
          forcePopupIcon={false} // Garante que não force a exibição
          popupIcon={null}
          getOptionLabel={option => {
            if (typeof option === 'string') return option
            return option.name || '' // Retorna apenas o nome limpo
          }}
          // 2. O que aparece na LISTA de opções (Dropdown):
          renderOption={option => {
            if (option.inputValue) {
              // Aqui colocamos o texto fixo "Adicionar" em vez de depender da tradução quebrada
              return `Adicionar "${option.inputValue}"`
            }
            return option.number
              ? `${option.name} - ${option.number}`
              : option.name
          }}
          renderInput={params => (
            <div className={classes.inputWrapper}>
              <span>{label || i18n.t('common.contact')}</span>
              <TextField
                {...params}
                variant="outlined"
                autoFocus
                placeholder={placeholder}
                onChange={e => setSearchParam(e.target.value)}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  )
                }}
              />
            </div>
          )}
        />
      </Grid>
    </Grid>
  )
}
